/**
 * AUTO-GENERATED FILE - DO NOT EDIT
 * Generated from: core.fga
 * Run: pnpm run gen:permissions -- core
 */

import type { ModulePermissions } from './types';

export const corePermissions = {
  module: 'core',
  displayName: 'Core',
  entities: [
    {
      name: 'customAttribute',
      displayName: 'Custom Attribute',
      permissions: [
        { key: 'customAttributeRead', action: 'Read', category: 'crud' },
        { key: 'customAttributeCreate', action: 'Create', category: 'crud' },
        { key: 'customAttributeUpdate', action: 'Update', category: 'crud' },
        { key: 'customAttributeDelete', action: 'Delete', category: 'crud' },
      ],
    },
    {
      name: 'facility',
      displayName: 'Facility',
      permissions: [
        { key: 'facilityRead', action: 'Read', category: 'crud' },
        { key: 'facilityCreate', action: 'Create', category: 'crud' },
        { key: 'facilityUpdate', action: 'Update', category: 'crud' },
        { key: 'facilityDelete', action: 'Delete', category: 'crud' },
      ],
    },
    {
      name: 'facilityGroup',
      displayName: 'Facility Group',
      permissions: [
        { key: 'facilityGroupRead', action: 'Read', category: 'crud' },
        { key: 'facilityGroupCreate', action: 'Create', category: 'crud' },
        { key: 'facilityGroupUpdate', action: 'Update', category: 'crud' },
        { key: 'facilityGroupDelete', action: 'Delete', category: 'crud' },
      ],
    },
    {
      name: 'organization',
      displayName: 'Organization',
      permissions: [
        { key: 'organizationRead', action: 'Read', category: 'crud' },
        { key: 'organizationUpdate', action: 'Update', category: 'crud' },
        { key: 'organizationDelete', action: 'Delete', category: 'crud' },
      ],
    },
    {
      name: 'outboxEvent',
      displayName: 'Outbox Event',
      permissions: [
        { key: 'outboxEventRead', action: 'Read', category: 'crud' },
      ],
    },
    {
      name: 'permission',
      displayName: 'Permission',
      permissions: [
        { key: 'permissionRead', action: 'Read', category: 'crud' },
        { key: 'permissionUpdate', action: 'Update', category: 'crud' },
      ],
    },
    {
      name: 'role',
      displayName: 'Role',
      permissions: [
        { key: 'roleRead', action: 'Read', category: 'crud' },
        { key: 'roleCreate', action: 'Create', category: 'crud' },
        { key: 'roleUpdate', action: 'Update', category: 'crud' },
        { key: 'roleDelete', action: 'Delete', category: 'crud' },
      ],
    },
    {
      name: 'settings',
      displayName: 'Settings',
      permissions: [
        { key: 'settingsRead', action: 'Read', category: 'crud' },
        { key: 'settingsManage', action: 'Manage', category: 'custom' },
      ],
    },
    {
      name: 'user',
      displayName: 'User',
      permissions: [
        { key: 'userRead', action: 'Read', category: 'crud' },
        { key: 'userCreate', action: 'Create', category: 'crud' },
        { key: 'userUpdate', action: 'Update', category: 'crud' },
        { key: 'userDelete', action: 'Delete', category: 'crud' },
      ],
    },
  ],
} as const satisfies ModulePermissions;

/**
 * Union type of all permission keys in the Core module
 */
export type CorePermissionKey =
  | 'customAttributeRead'
  | 'customAttributeCreate'
  | 'customAttributeUpdate'
  | 'customAttributeDelete'
  | 'facilityRead'
  | 'facilityCreate'
  | 'facilityUpdate'
  | 'facilityDelete'
  | 'facilityGroupRead'
  | 'facilityGroupCreate'
  | 'facilityGroupUpdate'
  | 'facilityGroupDelete'
  | 'organizationRead'
  | 'organizationUpdate'
  | 'organizationDelete'
  | 'outboxEventRead'
  | 'permissionRead'
  | 'permissionUpdate'
  | 'roleRead'
  | 'roleCreate'
  | 'roleUpdate'
  | 'roleDelete'
  | 'settingsRead'
  | 'settingsManage'
  | 'userRead'
  | 'userCreate'
  | 'userUpdate'
  | 'userDelete';
